export const LOGIN_ERROR = "LOGIN_ERROR";
export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const LOGIN_LOADING_START = "LOGIN_LOADING_START";
export const LOGIN_LOADING_FINISH = "LOGIN_LOADING_FINISH";
